import React from "react";
import WorkCasePage from "../components/workcase/WorkCasePage";
import imgMarbin from "../assets/img/img-work-marbin.png";

function Marbin() {
  return (
    <WorkCasePage
      title="marb.in"
      heroImage={imgMarbin}
      heroAlt="marb.in — Street-Photography Galerie"
      siteUrl="https://marb.in/"
      siteLabel="marb.in öffnen"
    >
      <p>
        Persönliche Street-Photography-Galerie mit Anbindung an Cloudinary für
        Bildauslieferung und -optimierung — schlanke Galerie, schnelle Ladezeiten,
        klare Präsentation der Arbeiten.
      </p>
      <p>
        Von der Bildpipeline über Layout bis zu den Details (Lazy Loading,
        responsive Raster) ist das Projekt als kleines, gut wartbares System
        gedacht.
      </p>
    </WorkCasePage>
  );
}

export default Marbin;
